React = require 'react'
t = require('views/internal/recup-with-helpers')('org_account')
track = require 'debug/track'
l = require 'lib/localize'

module.exports = class extends React.Component
  displayName: 'BoardCreateVisibilityRestrictionsComponent'

  render: t.renderable ->
    { onNewTabClick, publicBoardCount, restrictions, visibility } = @props

    t.div '.setting-item-detail', ->
      t.div '.markeddown', ->
        t.div ->
          t.p ->
            if restrictions[visibility]
              t.format ['board create visibility', visibility, restrictions[visibility]]
              if visibility == 'public' && restrictions[visibility] != 'none'
                t.span ->
                  t.text " #{t.l(['enterprise', 'public-boards-explanation'])}"
            else
              t.format ['enterprise',  'board create visibility', visibility]

          if visibility == 'public'
            t.div '.public-board-count-container', ->
              t.span '.public-board-text-container', ->
                if publicBoardCount > 1
                  t.format 'public-board-count-multiple', { publicBoardCount }
                else
                  t.format 'public-board-count-single', { publicBoardCount }
                t.b ->
                  onNewTabClick('boards/public')
                , '.public-boards-link', ->
                  t.format 'view-boards'



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/teams-settings/board-create-visibility-restrictions-component.coffee